import * as apiConstants from "../constants/Api";

const isPendingTermsAndConditionsError = error => {
  return (
    error.status === apiConstants.UNPROCESSABLE_ENTITY_CODE &&
    parseError(error).errorName === "PendingTermsAndConditionsError"
  );
};

export const handleAuthError = (error, otherErrorsHandler) => {
  if (
    error.status === apiConstants.UNAUTHORIZED_CODE ||
    isPendingTermsAndConditionsError(error)
  ) {
    window.location.replace("/");
  } else {
    otherErrorsHandler();
  }
};

export const parseError = error => {
  let parsedError;

  try {
    parsedError = JSON.parse(error.response.text);
  } catch (error) {}

  if (!parsedError && error instanceof Error) {
    parsedError = {
      name: error.name,
      message: error.message
    };
  } else if (!parsedError) {
    parsedError = {};
  }

  return {
    errorName: parsedError.name,
    message: parsedError.message
  };
};
